module.exports = __webpack_public_path__ + "html/video-gallery_1b6055c80a3a5d956b4d5e21168414ee.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/video-gallery.html
// module id = 1Z0F
// module chunks = 1